
<style scoped lang="less">
.contextmenu {margin: 0;background: #fff;z-index: 3000;position: fixed;list-style-type: none;padding: 5px 0;border-radius: 4px;font-size: 12px;font-weight: 400;color: #333;box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);background:rgba(33,185,191,.9);border:none;}
.contextmenu li {margin: 0;padding: 7px 16px;cursor: pointer;color: #fff !important;}
</style>

<template>
  <ul v-if="this.visible" ref="contextmenu" :style="{left:this.styleobj.left+'px',top:this.styleobj.top+'px'}" class="contextmenu">
    <li @click="setopacity()">设置透明度</li>
  </ul>
</template>

<script>
export default {
  props: ['styleobj', 'visible', 'layername'],
  data()
  {
    return {
    }
  },
  methods:
  {
    setopacity()
    {
      if (this.layername)
      {
        let show = !this.$store.state.transfrom
        this.$emit('setTransParents', {show: show, layername: this.layername})
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/plugins/app/assembly/kyyzt/RightMenu.vue